import type { OwaDate } from "owa-datetime";
import { getTimezoneOffset, endOfDay, startOfDay } from "owa-datetime";

/**
 * Represents the type of Daylight Saving Time (DST) transition.
 * - Start: The clock moves forward (spring forward, 23-hour day).
 * - End: The clock moves backward (fall back, 25-hour day).
 */
export enum DSTTransitionType {
    Start = "start",
    End = "end"
}

/**
 * Determines whether the given date corresponds to a DST transition.
 *
 * @param date The date to evaluate.
 * @returns
 * - DSTTransitionType.Start if DST begins (spring forward, 23-hour day).
 * - DSTTransitionType.End if DST ends (fall back, 25-hour day).
 * - undefined if the date is not a transition date.
 */
export function getDSTTransitionType(date: OwaDate): DSTTransitionType | undefined {
    const startOfDayOffset = getTimezoneOffset(startOfDay(date));
    const endOfDayOffset = getTimezoneOffset(endOfDay(date));
    
    if (startOfDayOffset === endOfDayOffset) {
        return undefined;
    }
    
    // DST end (fall back): offset increases (e.g., 420 -> 480).
    // DST start (spring forward): offset decreases (e.g., 480 -> 420).
    return endOfDayOffset > startOfDayOffset ? DSTTransitionType.End : DSTTransitionType.Start;
}
